import { render, staticRenderFns } from "./CRUDTableDetail2.vue?vue&type=template&id=c8b83e5c"
import script from "./CRUDTableDetail2.vue?vue&type=script&lang=js"
export * from "./CRUDTableDetail2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports